import React, { useState, useEffect } from 'react';
import axios from "axios";
import { server_address as proxy, websocket_address } from '../custom-modules/serverAddress';
import { v4 as uuid } from 'uuid';
import './styles/room1.scss';

import loading from '../Assets/loading.gif';
import error1 from '../Assets/error1.png';



function Room1() 
{
    const [websocket, set_websocket] = useState(null);   
    const [websocket_ready_state, set_websocket_ready_state] = useState(WebSocket.CLOSED);

    useEffect(() => 
    {
        const new_websocket = new WebSocket(websocket_address);
        set_websocket_ready_state(WebSocket.CONNECTING);
        new_websocket.onopen = () => set_websocket_ready_state(WebSocket.OPEN);
        new_websocket.onclose = () => set_websocket_ready_state(WebSocket.CLOSED);
        set_websocket(new_websocket);

        // websocket.addEventListener("open", (e) => 
        // {
        //     console.log("Attempted connection to WebSocket...");
        // });

    }, []);

    console.log(websocket_ready_state.valueOf())

    const [is_loaded, set_is_loaded] = useState(false);
    const [is_logged_in, set_is_logged_in] = useState(false);
    const [user_info, set_user_info] = useState({});
    const [messages, set_messages] = useState([]);
    const [msg_input, set_msg_input] = useState("");

    if (!is_loaded)
    {

        if (localStorage.getItem("user-id") == null || localStorage.getItem("user-id") == "")
        {
            set_is_logged_in(false);
            set_is_loaded(true);
        }
        else
        {
            axios.post(`${proxy}/doesUserExistsById`, { id: localStorage.getItem("user-id") })
                .then((res) => 
                {
                    let data = res.data;

                    if (data == "1")
                    {
                        set_is_logged_in(true);
                        
                        axios.post(`${proxy}/getUserById`, { id: localStorage.getItem("user-id") })
                            .then((res) => 
                            {
                                set_user_info(res.data[0]);

                                axios.post(`${proxy}/getMsg`)
                                .then((res) => 
                                {
                                    if (res.data == null) return;
                                    set_messages(res.data.reverse());
                                    console.log(res.data);
                                    set_is_loaded(true);
                                })
                                .catch((err) => console.error(err));
                            })
                            .catch((err) => console.error(err));
                    }
                    else
                    {
                        set_is_logged_in(false);
                        set_is_loaded(true);
                    }
                })
                .catch((err) => console.error(err));
        }


    }

    // let msggggg = messages.reverse();
    // console.log(messages)

    if (websocket != null)
    {
        websocket.addEventListener("message", (e) =>
            {
                // console.log(e.data)
                try
                {
                    let data = JSON.parse(e.data);
                    console.log(data)
                }
                catch (err)
                {
                    return;
                }
                const new_msg = JSON.parse(e.data);
        
        
                let new_messages = messages;
                new_messages = [new_msg, ...new_messages];
                // new_messages = new_messages;
        
                set_messages(new_messages);
            });
    }



    function setup_msg_input(value)
    {
        value = value.toString();

        if (value.includes("'")) return;
        set_msg_input(value);
    }

    function send_msg(e)
    {
        e.preventDefault();

        const date = new Date();
        let msg = msg_input;
        let user_id = localStorage.getItem("user-id");
        let date_of_creation = `${(date.getHours().toString().length == 1) ? `0${date.getHours()}` : date.getHours()}:${(date.getMinutes().toString().length == 1) ? `0${date.getMinutes()}` : date.getMinutes()} - ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

        set_msg_input("");

        let ws_msg = { msg_id: uuid(), user_id: user_id, msg: msg, date_of_creation: date_of_creation, username: user_info.username, color: user_info.color };
        ws_msg = JSON.stringify(ws_msg);

        websocket.send(ws_msg);

        // let new_messages = messages;
        // new_messages = (new_messages.length == 0) ? [ws_msg] : [ws_msg, ...new_messages];
        // new_messages = new_messages;

        // set_messages(new_messages);



        axios.post(`${proxy}/sendMsg`, { msg_id: uuid(), user_id: user_id, msg: msg, date_of_creation: date_of_creation })
            .then((res) => 
            {
                // set_is_loaded(false);
            })
            .catch((err) => console.error(err));
    }


    if (!is_loaded) return (
        <div><img src={loading} style={{ width: "20px" }} /></div>
    );

    // bruh

    function nothing11()
    {

    }
    
    if (!is_logged_in) return (
        <div style={{ width: "100%", height: "100vh", display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <img src={error1} style={{ width: "80px" }} />
            <h1>Sorry! This page does not exist!</h1>
            <span>This page might be taken down or you have miss-entered the url!</span>
        </div>
    );

  return (
    <div className="content-container">
        <div className="msg-title">
            <h1>Private Chatroom</h1>
            <span>Only <strong>PopularSun</strong> can view and moderate your messages.</span>
        </div>
        <div className="msg-container"> 
            
            {
                messages.map((value, index) =>
                    <div className="msg" style={(index % 2 != 0) ? { backgroundColor: "rgb(63, 63, 63)" } : {}}>
                        <strong style={value.color == null ? {} : { color: value.color }}>[{value.username}] </strong>
                        <span style={{ color: "gray" }}>[{value.date_of_creation}] </span>
                        <span>{value.msg}</span>
                    </div>
                )
            }
                
            
        </div>
        <form className="msg-create">
            <div className="field msg-create-field"><input className="input-field" type="text" placeholder="write your message..." maxLength={1000} value={msg_input} onInput={(e) => setup_msg_input(e.target.value)} /></div>
            <button className="btn" onClick={send_msg}><strong>Send</strong></button>
        </form>
    </div>
  );
}

export default Room1;